// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2EEj9","inner":"Footer_inner__3oJmR"};